import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { TradingEntityDetail } from 'api'
import { DataGrid, GridId } from 'view/components/datagrid'
import { allTradingEntityDetailsSelector } from 'selectors/tradingEntitySelectors'
import { TradingEntityColumnDefs, tradingEntityGridOptions } from './TradingEntityGridModel'

interface TradingEntityGridProps {
  tradingEntityList: TradingEntityDetail[]
}

const mapStateToProps = createStructuredSelector({
  tradingEntityList: allTradingEntityDetailsSelector
})

export const TradingEntityGridComponent: React.FunctionComponent<TradingEntityGridProps> = props => {
  return (
    <DataGrid
      gridId={GridId.AdminTradingEntityGrid}
      gridOptions={tradingEntityGridOptions}
      rowData={props.tradingEntityList}
      columnDefs={TradingEntityColumnDefs}
    />
  )
}

export const TradingEntityGrid = connect(mapStateToProps)(TradingEntityGridComponent)
